// Integrated Academy course catalog.
// Add additional courses to this array — order in the array = order on the page.
const PURCHASE_BASE =
  "https://john-campetella-john-campetella-s-school.teachable.com/purchase?product_id=";
const TC = (id) =>
  `https://uploads.teachablecdn.com/attachments/${id}.png`;

export const COURSES = [
  {
    id: "unified-medical-model",
    title: "The Unified Medical Model",
    subtitle: "AI-Guided Clinical Care for Healthcare Providers",
    audience: "For Clinicians & Healthcare Providers",
    image: TC("b11999b55c324f11bd53f41f1009bd5e"),
    purchaseUrl: `${PURCHASE_BASE}6732539`,
    price: "$500",
    description: [
      "Orients healthcare providers to the Integrated Wellness clinical ecosystem — a unified medical model that integrates prevention, optimization, and longitudinal care.",
      "Establishes a shared clinical framework grounded in safety, consistency, and evidence-informed decision-making — so every provider operates from the same conceptual and operational foundation.",
      "Providers learn how AI functions as a clinical co-pilot — organizing data, standardizing assessments, and supporting clinical reasoning — while preserving clinician authority and accountability.",
    ],
    badges: ["Flagship Course", "Provider Training", "AI-Guided"],
  },
  {
    id: "peptide-therapy",
    title: "Advanced Clinical Training: Peptide Therapy",
    subtitle: "For the IWMC Medical Team",
    audience: "For Clinicians & Healthcare Providers",
    image: TC("405ed54f93fc408da7adfc7475123906"),
    purchaseUrl: `${PURCHASE_BASE}6732586`,
    price: "$500",
    description: [
      "Master the clinical application of peptide therapeutics — one of functional medicine's most powerful yet misunderstood intervention categories.",
      "Transforms peptides from a regulatory gray zone into evidence-based clinical tools you can confidently prescribe and monitor — with clinical competence and legal compliance.",
      "Sits at the intersection of cutting-edge science and clinical pragmatism, with a curriculum built on current safety and efficacy data.",
    ],
    badges: ["Tier 4 · Advanced Therapeutics", "Clinical Training"],
  },
  {
    id: "hormone-optimization",
    title: "Integrated Wellness Hormone Optimization",
    subtitle: "Hormones as a control system for energy, mood, body composition, sleep, and resilience",
    audience: "For Clinicians & Practitioners",
    image: TC("6f142a9f6f0d4dcda9fa90b673521342"),
    purchaseUrl: `${PURCHASE_BASE}6732587`,
    price: "$500",
    description: [
      "A focused module within the broader Integrated Wellness program — designed to help you understand hormones as a control system that influences energy, mood, body composition, sleep, and long-term resilience.",
      "Grounded in IWMC's core principles — evidence-based, patient-centered, safety-first, and trend-focused over time.",
      "Teaches you to assess hormone-related patterns, interpret biomarkers in context, and apply practical lifestyle strategies that stabilize the foundation before adding complexity.",
    ],
    badges: ["Hormone Optimization", "Clinical Module"],
  },
  {
    id: "beyond-the-prescription",
    title: "Beyond the Prescription",
    subtitle: "Repurposed Medications & Alternative Therapies for Whole-Person Wellness",
    audience: "Evidence-Based Course",
    image: TC("b9a9a6b00fee4f9cae18d0167457f711"),
    purchaseUrl: `${PURCHASE_BASE}6732588`,
    price: "$500",
    description: [
      "A clear, evidence-based education on repurposed medications and alternative wellness therapies — what works, what doesn't, who they're for, and how to use them safely.",
      "Covers recovery modalities like red light therapy, sauna, and cold plunge — backed by more science than most people realize.",
      "Every module is grounded in peer-reviewed research from 2024–2025, organized within a four-tier clinical framework used in real-world integrative medicine.",
    ],
    badges: ["Evidence-Based", "Integrative Medicine"],
  },
  {
    id: "coaching-program",
    title: "Integrated Wellness Coaching Program",
    subtitle: "NBHWC-aligned coaching grounded in the IWMC clinical framework",
    audience: "For Coaches & Health Professionals",
    image: TC("c0ab4bc1fe5744bfa54381baeaf2d2f0"),
    purchaseUrl: `${PURCHASE_BASE}6732589`,
    price: "$500",
    description: [
      "A comprehensive, NBHWC-aligned training that prepares you to coach clients toward lasting, whole-person health transformations — across 9 modules and 25+ lessons.",
      "Master behavior-change science, motivational interviewing, ethical coaching relationships, the Transtheoretical Model of Change, and IWMC's 7-composite scoring system.",
      "Run complete 8–12 week coaching programs from intake through graduation — with case studies, structured lesson summaries, and graded assessments built in.",
    ],
    badges: ["NBHWC-Aligned", "Coach Certification Track"],
  },
];
